import React from 'react';
import { Form } from 'react-bootstrap';

const TimeInput = ({
  label,
  name,
  placeholder = '00:00:00',
  register,
  errors,
  watch,
  setValue,
  rules = {},
}) => {
  const handleChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    
    if (value.length > 6) {
      value = value.slice(0, 6);
    }
    
    let formatted = '';
    if (value.length > 0) {
      formatted = value.slice(0, 2);
    }
    if (value.length > 2) {
      formatted += ':' + value.slice(2, 4);
    }
    if (value.length > 4) {
      formatted += ':' + value.slice(4, 6);
    }
    
    e.target.value = formatted;
    setValue(name, formatted, { shouldValidate: true });
  };

  const validateTime = (value) => {
    if (!value) {
      return true;
    }
    
    if (!/^\d{2}:\d{2}:\d{2}$/.test(value)) {
      return 'Formato inválido. Use 00:00:00';
    }
    
    const [hours, minutes, seconds] = value.split(':').map(Number);
    
    if (hours < 0 || hours > 23) {
      return 'Hora inválida (0-23)';
    }
    
    if (minutes < 0 || minutes > 59) {
      return 'Minuto inválido (0-59)';
    }
    
    if (seconds < 0 || seconds > 59) {
      return 'Segundo inválido (0-59)';
    }
    
    return true;
  };

  const combinedValidate = (value) => {
    const timeValidation = validateTime(value);
    if (timeValidation !== true) {
      return timeValidation;
    }
    
    if (rules.validate) {
      const customValidation = rules.validate(value);
      if (customValidation !== true) {
        return customValidation;
      }
    }
    
    return true;
  };

  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label className="mb-1">{label}</Form.Label>
      <Form.Control
        type="text"
        placeholder={placeholder}
        maxLength={8}
        {...register(name, {
          ...rules,
          validate: combinedValidate,
          onChange: handleChange,
        })}
        isInvalid={!!errors[name]}
      />
      <Form.Control.Feedback type="invalid">
        {errors[name] && errors[name].message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default TimeInput;

